import { makeStyles } from "@mui/styles"; 
import { Theme } from "@mui/material/styles";

export const useStyles = makeStyles((theme: Theme) => ({
   dialogTitle: {
    '&.MuiDialogTitle-root':{
      margin: 0,
      padding: theme.spacing(2),
    }
  },
   closeButton: {
    '&.MuiButtonBase-root':{
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    }

  },
  formControlLabel:{
    '&.MuiFormControlLabel-root .MuiFormControlLabel-label':{
      fontSize: '14px'
    }
  },
  accordion: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  accordionSummary: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  accordionSummaryContent: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  accordionDetails: {
    padding: theme.spacing(2),
  },
  alert: {
    display: 'flex',
    alignItems: 'center',
    padding: 10,
    borderRadius: 5,
    backgroundColor: '#F5F5F5',
  },
}));